"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SystemColorDestination = void 0;
var tslib_1 = require("tslib");
var enums_1 = require("../../../../../core/model/themes/enums");
var translation_tables_1 = require("../../../../translation-table/translation-tables");
var drawing_color_properties_destination_base_1 = require("./drawing-color-properties-destination-base");
var SystemColorDestination = (function (_super) {
    tslib_1.__extends(SystemColorDestination, _super);
    function SystemColorDestination() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    SystemColorDestination.prototype.setColorPropertyValue = function (reader) {
        var systemColor = this.data.readerHelper.getWpEnumValue(reader, 'val', translation_tables_1.TranslationTables.systemColorTable.importMap, enums_1.SystemColorValues.Empty);
        if (systemColor == enums_1.SystemColorValues.Empty)
            this.data.options.throwInvalidFile('Invalid color values');
        this.colorModelInfo.systemColor = systemColor;
    };
    return SystemColorDestination;
}(drawing_color_properties_destination_base_1.DrawingColorPropertiesDestinationBase));
exports.SystemColorDestination = SystemColorDestination;
